export interface OAuthConfig {
  wordpressUrl: string;
  oauth: {
    authorizeUrl: string;
    tokenUrl: string;
    userInfoUrl: string;
    membershipApiEndpoint: string;
    clientId: string;
    clientSecret: string;
    redirectUri: string;
    scope: string[];
  };
  api: {
    membershipEndpoint: string;
    userInfoEndpoint: string;
  };
}

export interface MembershipLevel {
  id: string;
  name: string;
  description: string;
  features: string[];
  maxPets: number;
  canAccessAI: boolean;
  canAccessAdvancedAnalytics: boolean;
  canExportData: boolean;
}

export interface UserMembership {
  userId: string;
  memberships: MembershipLevel[];
  activeLevel: MembershipLevel | null;
  expiresAt?: string;
  isActive: boolean;
}

export const MEMBERSHIP_LEVELS: MembershipLevel[] = [
  {
    id: 'basic',
    name: 'Basic',
    description: 'Suivi santé de base pour votre animal',
    features: ['Suivi quotidien', 'Graphiques de base', 'Alertes simples'],
    maxPets: 1,
    canAccessAI: false,
    canAccessAdvancedAnalytics: false,
    canExportData: false
  },
  {
    id: 'premium',
    name: 'Premium',
    description: 'Fonctionnalités avancées et IA',
    features: ['Suivi illimité', 'IA santé', 'Analytiques avancées', 'Export PDF'],
    maxPets: 5,
    canAccessAI: true,
    canAccessAdvancedAnalytics: true,
    canExportData: true
  },
  {
    id: 'veterinary',
    name: 'Vétérinaire',
    description: 'Outils professionnels pour vétérinaires',
    features: ['Multi-patients', 'Diagnostic IA', 'Rapports détaillés', 'API complète'],
    maxPets: -1, // Illimité
    canAccessAI: true,
    canAccessAdvancedAnalytics: true,
    canExportData: true
  }
];

export const getOAuthConfig = (): OAuthConfig => ({
  wordpressUrl: import.meta.env.VITE_WORDPRESS_URL || 'https://staging.drvictoria.vet',
  oauth: {
    authorizeUrl: import.meta.env.VITE_OAUTH_AUTHORIZE_URL || 'https://staging.drvictoria.vet/wp-json/moserver/authorize',
    tokenUrl: import.meta.env.VITE_OAUTH_TOKEN_URL || 'https://staging.drvictoria.vet/wp-json/moserver/token',
    userInfoUrl: import.meta.env.VITE_USERINFO_API_ENDPOINT || 'https://staging.drvictoria.vet/wp-json/wp/v2/users/me',
    membershipApiEndpoint: import.meta.env.VITE_MEMBERSHIP_API_ENDPOINT || 'https://staging.drvictoria.vet/wp-json/drvictoria/v1/membership',
    clientId: import.meta.env.VITE_OAUTH_CLIENT_ID || 'gSCunwcNPfIldpGyvhoIFOooAzrRespA',
    clientSecret: import.meta.env.VITE_OAUTH_CLIENT_SECRET || 'vyiQVXBNfgUkMvhJtGWHnhDwCLxwqrPP',
    redirectUri:
      import.meta.env.VITE_OAUTH_REDIRECT_URI ||
      (typeof window !== 'undefined' ? `${window.location.origin}/oauth/callback` : 'http://localhost:3000/oauth/callback'),
    scope: []
  },
  api: {
    membershipEndpoint: import.meta.env.VITE_MEMBERSHIP_API_ENDPOINT || 'https://votre-site-wordpress.com/wp-json/drvictoria/v1/membership',
    userInfoEndpoint: import.meta.env.VITE_USERINFO_API_ENDPOINT || 'https://votre-site-wordpress.com/wp-json/wp/v2/users/me'
  }
});

export const validateOAuthConfig = (): boolean => {
  const config = getOAuthConfig();
  const required = [
    config.oauth.clientId,
    config.oauth.clientSecret,
    config.wordpressUrl
  ];
  
  const missing = required.filter(field => !field || field === '');
  
  if (missing.length > 0) {
    console.warn('OAuth configuration missing:', missing);
    return false;
  }
  
  return true;
};
